export * from './tm-flooring-product-detail'
export * from './tm-furniture-product-detail'
export * from './tm-synsisal-product-detail'
